import Vue from 'vue';
import VueRouter from 'vue-router';
import JSBridge from '@/utils/js-bridge';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    // 根路径（www.chunyutianxia.com/）直接渲染优选商城，地址栏保持不变
    component: () =>
      import(
        /* webpackChunkName: 'goods-home' */ '@/views/GoodsHome/index.vue'
      ),
    meta: {
      title: '优选商城',
      actionBarVisible: true,
      keepAlive: false,
    },
  },
  {
    path: '/RedirectToNative',
    name: 'RedirectToNative',
    component: () =>
      import(
        /* webpackChunkName: 'redirect-to-native' */ '@/views/Redirect/RedirectToNative.vue'
      ),
    meta: {
      title: '正在跳转...',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/goods-home',
    name: 'GoodsHome',
    component: () =>
      import(
        /* webpackChunkName: 'goods-home' */ '@/views/GoodsHome/index.vue'
      ),
    meta: {
      title: '优选商城',
      actionBarVisible: true,
      keepAlive: false,
    },
  },
  {
    path: '/goods-detail/:id',
    name: 'GoodsDetail',
    component: () =>
      import(
        /* webpackChunkName: 'goods-detail' */ '@/views/GoodsHome/GoodsDetail/index.vue'
      ),
    props: true,
    meta: {
      title: '商品详情',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/pay-confirm',
    name: 'PayConfirm',
    component: () =>
      import(
        /* webpackChunkName: 'pay-confirm' */ '@/views/GoodsHome/PayConfirm/index.vue'
      ),
    meta: {
      title: '确认订单',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/goods-login',
    name: 'GoodsLogin',
    component: () =>
      import(
        /* webpackChunkName: 'goods-login' */ '@/views/GoodsHome/Login/index.vue'
      ),
    meta: {
      title: '登录',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/products',
    name: 'ProductList',
    component: () =>
      import(
        /* webpackChunkName: 'product-list' */ '@/views/ProductList/index.vue'
      ),
    meta: {
      title: '列表',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/products-discounts-list',
    name: 'ProductDiscountsList',
    component: () =>
      import(
        /* webpackChunkName: 'products-discounts-list' */ '@/views/ProductDiscountsList/index.vue'
      ),
    meta: {
      title: '指定商品优惠',
      actionBarVisible: false,
    },
  },
  {
    path: '/product/:id',
    name: 'Product',
    component: () =>
      import(/* webpackChunkName: 'product' */ '@/views/Product/index.vue'),
    props: true,
    meta: {
      title: '详情',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/product/shop-spu/:id',
    name: 'ProductShopSpu',
    component: () =>
      import(/* webpackChunkName: 'product' */ '@/views/Product/index.vue'),
    props: true,
    meta: {
      title: '详情',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/cart',
    name: 'ShoppingCart',
    component: () =>
      import(
        /* webpackChunkName: 'shopping-cart' */ '@/views/ShoppingCart/index.vue'
      ),
    meta: {
      title: '购物车',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: () =>
      import(
        /* webpackChunkName: 'payment-success' */ '@/views/PaymentSuccess/index.vue'
      ),
    meta: {
      title: '支付成功',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/addresses',
    name: 'AddressList',
    component: () =>
      import(
        /* webpackChunkName: 'address-list' */ '@/views/AddressList/index.vue'
      ),
    meta: {
      title: '收货地址',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/address/create',
    name: 'AddressCreate',
    component: () =>
      import(/* webpackChunkName: 'address' */ '@/views/Address/index.vue'),
    meta: {
      title: '编辑地址',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/address/:id/edit',
    name: 'AddressEdit',
    component: () =>
      import(/* webpackChunkName: 'address' */ '@/views/Address/index.vue'),
    props: true,
    meta: {
      title: '编辑地址',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/order/:id/unpaid',
    name: 'OrderUnpaid',
    component: () =>
      import(
        /* webpackChunkName: 'order-unpaid' */ '@/views/OrderUnpaid/index.vue'
      ),
    meta: {
      title: '订单',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/order/:id/paid',
    name: 'OrderPaid',
    component: () =>
      import(
        /* webpackChunkName: 'order-paid' */ '@/views/OrderPaid/index.vue'
      ),
    meta: {
      title: '订单',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/order/:id/reject',
    name: 'OrderReject',
    component: () =>
      import(
        /* webpackChunkName: 'order-reject' */ '@/views/OrderReject/index.vue'
      ),
    meta: {
      title: '订单',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () =>
      import(
        /* webpackChunkName: 'order-reject' */ '@/views/Subscribe/index.vue'
      ),
    meta: {
      title: '预约详情',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () =>
      import(/* webpackChunkName: 'preview' */ '@/views/Preview/index.vue'),
    meta: {
      title: '图片详情',
      keepAlive: false,
      actionBarVisible: false,
    },
  },

  {
    path: '/goods-evaluate',
    name: 'GoodsEvaluate',
    component: () =>
      import(
        /* webpackChunkName: 'goods-evaluate' */ '@/views/GoodsEvaluate/index.vue'
      ),
    meta: {
      title: '商品评价',
      keepAlive: false,
      actionBarVisible: false,
    },
  },

  {
    path: '/goods-qa',
    name: 'GoodsQa',
    component: () =>
      import(/* webpackChunkName: 'goods-qa' */ '@/views/GoodsQa/index.vue'),
    meta: {
      title: '相关问诊',
      keepAlive: false,
      actionBarVisible: false,
    },
  },

  {
    path: '/med-supplies',
    name: 'MedSupplies',
    component: () =>
      import(
        /* webpackChunkName: 'med-supplies' */ '@/views/MedSupplies/index.vue'
      ),
    meta: {
      title: '治疗建议',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/error-tips',
    name: 'ErrorTips',
    component: () =>
      import(
        /* webpackChunkName: 'error-tips' */ '@/views/ErrorTips/index.vue'
      ),
    meta: {
      title: 'Error',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/app-login',
    name: 'AppLogin',
    component: () =>
      import(/* webpackChunkName: 'app-login' */ '@/views/AppLogin/index.vue'),
    meta: {
      title: '跳转中...',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/id-card',
    name: 'IdCard',
    component: () =>
      import(/* webpackChunkName: 'id-card' */ '@/views/IdCard/index.vue'),
    meta: {
      title: '实名信息',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: 'not-found' */ '@/views/NotFound/index.vue'),
    meta: {
      title: '未找到该页面',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/off-shelf-goods',
    name: 'OffShelfGoods',
    component: () =>
      import(
        /* webpackChunkName: 'product-list' */ '@/views/OffShelpGoods/index.vue'
      ),
    meta: {
      title: '商品已下架',
      keepAlive: false,
      actionBarVisible: false,
    },
  },
  {
    path: '/contact-advisor',
    name: 'ContactAdvisor',
    component: () =>
      import(
        /* webpackChunkName: 'contact-advisor' */ '@/views/ContactAdvisor/index.vue'
      ),
    meta: {
      title: '添加助手',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/supplier-entry',
    name: 'SupplierEntry',
    component: () =>
      import(
        /* webpackChunkName: 'supplier-entry' */ '@/views/SupplierEntry/index.vue'
      ),
    meta: {
      title: '商家入驻',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/supplier-entry/apply',
    name: 'SupplierApply',
    component: () =>
      import(
        /* webpackChunkName: 'supplier-apply' */ '@/views/SupplierApply/index.vue'
      ),
    meta: {
      title: '入驻申请',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/supplier-entry/result',
    name: 'SupplierApplyResult',
    component: () =>
      import(
        /* webpackChunkName: 'supplier-apply-result' */ '@/views/SupplierApplyResult/index.vue'
      ),
    meta: {
      title: '申请结果',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/supplier-entry/product-upload',
    name: 'ProductUpload',
    component: () =>
      import(
        /* webpackChunkName: 'product-upload' */ '@/views/ProductUpload/index.vue'
      ),
    meta: {
      title: '发布商品',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
  {
    path: '/supplier-entry/product-upload/result',
    name: 'ProductUploadResult',
    component: () =>
      import(
        /* webpackChunkName: 'product-upload-result' */ '@/views/ProductUploadResult/index.vue'
      ),
    meta: {
      title: '上传结果',
      actionBarVisible: false,
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: 'v-m-mall/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '';
  JSBridge.setTitle(to.meta.title || '');
  next();
});

// fix: https://sentry.chunyutianxia.com/chunyu/vue/issues/78223/

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default router;
